import { Card, CardContent, Stack, Typography } from "@mui/material";
import React from "react";
import {
  DataGridPremium,
  type GridColDef,
  type GridRenderCellParams,
} from "@mui/x-data-grid-premium";

const snapshotStagesTableFields: GridColDef<SnapshotStage>[] = [
  {
    field: "modifiedAt",
    headerName: "Updated",
    width: 250,
  },
  {
    field: "createdAt",
    headerName: "Created",
    width: 250,
  },
  {
    field: "sourceName",
    headerName: "Source",
    width: 250,
  },
  {
    field: "status",
    headerName: "Status",
    width: 150,
    renderCell: (params: GridRenderCellParams<SnapshotStage>) => {
      let color;
      let text;
      switch (params.row.status.toLocaleLowerCase()) {
        case "completed":
          color = "green";
          text = "Completed";
          break;
        case "unknown":
          color = "red";
          text = "Unknown";
          break;
        case "error":
          color = "red";
          text = "Errored";
          break;
        default:
          color = "inherit";
          text = "In Progress";
          break;
      }
      return <Typography color={color}>{text}</Typography>;
    },
  },
];

const snapshotActivitiesTableFields = [
  {
    field: "messageTimestamp",
    headerName: "Msg. Time",
    width: 150,
  },
  {
    field: "createdAt",
    headerName: "Created",
    width: 150,
  },
  {
    field: "sourceName",
    headerName: "Source",
    width: 250,
  },
  {
    field: "status",
    headerName: "Status",
    width: 100,
    renderCell: (params: GridRenderCellParams<SnapshotVersionActivity>) => {
      let color;
      let text;
      switch (params.row.status.toLocaleLowerCase()) {
        case "success":
          color = "green";
          text = "Success";
          break;
        case "fail":
          color = "red";
          text = "Fail";
          break;
        case "inprogress":
          color = "inherit";
          text = "In Progress";
          break;
        default:
          color = "inherit";
          text = params.row.status;
          break;
      }
      return <Typography color={color}>{text}</Typography>;
    },
  },
  {
    field: "activity",
    headerName: "Activity",
    width: 100,
  },
  {
    field: "detail",
    headerName: "Detail",
    width: 200,
  },
];

export default function SnapshotDetailPanel(snapshot: {
  row: SnapshotVersion;
}) {
  return (
    <Stack
      sx={{
        p: 2,
        height: "100%",
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
      }}
      direction="column"
    >
      <Card sx={{ flex: 2, marginBottom: 2 }}>
        <CardContent
          sx={{ display: "flex", flexDirection: "column", height: "90%" }}
        >
          <Typography variant={"h6"}>Stages</Typography>
          <DataGridPremium
            sx={{
              flex: 1,
              // This is to override the default height of the footer row
              "& .MuiDataGrid-footerContainer": {
                height: "fit-content",
                minHeight: "fit-content",
              },
            }}
            getRowHeight={() => "auto"}
            density="compact"
            getRowId={(row) => row.id}
            columns={snapshotStagesTableFields}
            rows={snapshot.row.stages || []}
            rowSelection={false}
            initialState={{
              sorting: {
                sortModel: [{ field: "createdAt", sort: "desc" }],
              },
            }}
          />
        </CardContent>
      </Card>
      <Card sx={{ flex: 3 }}>
        <CardContent
          sx={{ display: "flex", flexDirection: "column", height: "90%" }}
        >
          <Typography variant={"h6"}>Activities</Typography>
          <DataGridPremium
            sx={{
              flex: 1,
              // This is to override the default height of the footer row
              "& .MuiDataGrid-footerContainer": {
                height: "fit-content",
                minHeight: "fit-content",
              },
            }}
            getRowHeight={() => "auto"}
            density="compact"
            getRowId={(row) => row.id}
            columns={snapshotActivitiesTableFields}
            rows={snapshot.row.activities || []}
            rowSelection={false}
            initialState={{
              sorting: {
                sortModel: [{ field: "createdAt", sort: "desc" }],
              },
            }}
          />
        </CardContent>
      </Card>
    </Stack>
  );
}
